export const PERFORMANCE_RULES_REPORT_ID = 'performance-rules';
